/* eslint-disable no-param-reassign */
export default (state, { payload }) => {
  const instanceIndex = state.trayInstances.findIndex((instance) => instance.id === payload.id);
  if (instanceIndex < 0) {
    state.trayInstances.push(payload);
  } else {
    state.trayInstances[instanceIndex] = payload;
  }

  state.inProgressTrayInstance = { instance: undefined, loading: undefined, success: undefined };
};
